import { Link } from "react-router";
import { CheckIcon, XMarkIcon } from "@heroicons/react/16/solid";

export const ProfileCompleteItem = ({ complete, title, link }) => {
    return (
        <div className="flex items-center py-2">
            <Link to={link} className="hover:underline">
                {title}
            </Link>
            {complete == 1 ? (
                <CheckIcon className="ms-auto size-6 text-emerald-50" />
            ) : (
                <XMarkIcon className="ms-auto size-6 text-red-600" />
            )}
        </div>
    );
};
